export type StateType = {
  vins: {
    [key: string]: string;
  };
  showModal: boolean;
};

export type ActionType =
  | { type: 'setVinError'; vehicleId: string; vin: string }
  | { type: 'setVinSuccess'; vehicleId: string }
  | { type: 'closeModal' }
  | { type: 'reset' };

export const initialState: StateType = {
  vins: {},
  showModal: false,
};

export const reducer = (state: StateType, action: ActionType): StateType => {
  switch (action.type) {
    case 'setVinError':
      return {
        ...state,
        showModal: true,
        vins: {
          ...state.vins,
          // add vin to object when there is a vin input error
          [action.vehicleId]: action.vin,
        },
      };
    case 'setVinSuccess':
      // remove from object when success
      const updatedVins = state.vins;
      delete updatedVins[action.vehicleId];

      return {
        ...state,
        vins: updatedVins,
      };
    case 'closeModal':
      return {
        ...state,
        showModal: false,
      };
    case 'reset':
      return initialState;
    default:
      return {
        ...state,
      };
  }
};
